import { createFileRoute, redirect } from '@tanstack/react-router'
import { HTTPError } from 'ky'
import { bootstrapQueryOptions } from '@/features/bootstrap/api/bootstrap/queries/bootstrap-query'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import PendingApprovalPage from '@/pages/pending-approval'
import { getApiErrorCode } from '@/shared/api/errors'

export const Route = createFileRoute('/$lang/pending-approval')({
  beforeLoad: async ({ context, params }) => {
    requireAuthenticated(context, params)

    try {
      await context.queryClient.fetchQuery(bootstrapQueryOptions())
      // Bootstrap succeeded — user is approved, go to app
      throw redirect({
        to: '/$lang/app',
        params: { lang: params.lang },
        replace: true,
      })
    } catch (error) {
      if (error instanceof HTTPError && error.response.status === 403) {
        const code = await getApiErrorCode(error)
        if (code === 'PENDING_APPROVAL_REQUIRED') {
          // PENDING_APPROVAL_REQUIRED — stay on page
          return
        }
      }
      throw error
    }
  },
  component: PendingApprovalPage,
  staticData: { layout: 'public' },
})
